import React, { useState } from 'react'
import { Input, Box, IconButton } from '@chakra-ui/react'
import { FiEye, FiEyeOff } from 'react-icons/fi'

interface PasswordInputProps extends Omit<React.ComponentProps<typeof Input>, 'type'> {
  value: string
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  name?: string
  placeholder?: string
  autoComplete?: string
}

/**
 * Password input component with show/hide password toggle.
 * Provides a consistent password input experience across the application.
 */
export const PasswordInput: React.FC<PasswordInputProps> = ({
  value,
  onChange,
  name,
  placeholder,
  autoComplete,
  ...inputProps
}) => {
  const [showPassword, setShowPassword] = useState(false)

  const toggleShowPassword = () => {
    setShowPassword(!showPassword)
  }

  return (
    <Box position="relative" w="full">
      <Input
        type={showPassword ? 'text' : 'password'}
        value={value}
        onChange={onChange}
        name={name}
        placeholder={placeholder}
        autoComplete={autoComplete}
        pr="3rem"
        {...inputProps}
      />
      <Box
        position="absolute"
        right="0.5rem"
        top="50%"
        transform="translateY(-50%)"
        zIndex={1}
      >
        <IconButton
          aria-label={showPassword ? 'Hide password' : 'Show password'}
          onClick={toggleShowPassword}
          variant="ghost"
          size="sm"
          h="1.75rem"
          w="1.75rem"
        >
          {showPassword ? <FiEyeOff /> : <FiEye />}
        </IconButton>
      </Box>
    </Box>
  )
}

